import Banner from "./Banner";
import ProductsList from "./ProductsList";
import ProductsFeatures from "./ProductsFeatures";

/* This example requires Tailwind CSS v2.0+ */
export default function Home() {
  return (
    <>
      <Banner />
      <ProductsList />
      <ProductsFeatures />
    </>
  );
}
